
import { defineComponent, PropType } from 'vue';
import { useI18n } from 'vue-i18n';
import InputText from 'primevue/inputtext';
import { RCS_REPRESENTATIVE_NAME_MAX_LENGTH } from '@/types/rcs-onboarding';
import type { RcsDedicatedFormState } from '@/types/rcs-onboarding';

export default defineComponent({
  name: 'RcsRepresentativeStep',

  components: { InputText },

  props: {
    form: {
      type: Object as PropType<RcsDedicatedFormState>,
      required: true,
    },
  },

  setup() {
    const { t } = useI18n();
    return {
      t,
      nameMaxLength: RCS_REPRESENTATIVE_NAME_MAX_LENGTH,
    };
  },
});
